module.exports = __webpack_public_path__ + "img/30.15530900.jpg";